var React = require('react');

function Check1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M44.432 3.213c1.028.868 1.202 2.462.39 3.56L20.046 40.288c-.382.533-.84.983-1.338 1.344l-.01.007c-2.6 1.86-6.117 1.125-7.87-1.64L3.1 28.27c-.754-1.144-.497-2.725.573-3.531 1.07-.806 2.549-.532 3.303.612l7.743 11.75.032.05c.288.46.873.585 1.305.28.1-.073.178-.155.234-.233l.026-.038L41.103 3.63c.812-1.099 2.303-1.285 3.33-.417z"}));
}

Check1.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Check1;

Check1.default = Check1;
